import { getIsNativePlatform } from 'utils/platform';

import { NATIVE_PLATFORM_CLASS } from './native.constants';

// Mark <html> as the native shell so the stylesheet can scope rules that must NOT reach the web
// build (selectable text is correct on web, and wrong in an app). Applied once at boot; the class
// never toggles, so styles.css can rely on it being present for the whole native session.
export const applyNativePlatformClass = () => {
  if (!getIsNativePlatform()) {
    return;
  }

  document.documentElement.classList.add(NATIVE_PLATFORM_CLASS);
};
